/**
 * DevExtreme (esm/__internal/scheduler/options_validator/core/types.js)
 * Version: 23.2.8
 * Build date: Fri Aug 09 2024
 *
 * Copyright (c) 2012 - 2024 Developer Express Inc. ALL RIGHTS RESERVED
 * Read about DevExtreme licensing here: https://js.devexpress.com/Licensing/
 */
export var REDUNDANT_EXPORT = void 0;
